import React from 'react';
import { Helmet } from 'react-helmet-async';
import { buildHomepageOfferCatalog } from '@/data/courses';

interface StructuredDataMarkupProps {
  type: 'homepage' | 'centre' | 'program';
  data: any;
}

const StructuredDataMarkup: React.FC<StructuredDataMarkupProps> = ({ type, data }) => {
  const generateSchemaMarkup = () => {
    switch (type) {
      case 'homepage':
        return {
          "@context": "https://schema.org",
          "@type": "EducationalOrganization",
          "name": "Schoolola",
          "alternateName": "Schoolola Tutoring",
          "description": "Australia's leading tutoring provider for students from Kindergarten, Prep or Pre-primary to Year 8. Premium in-centre and online tutoring with centres across NSW and Victoria, serving students Australia-wide.",
          "url": "https://schoolola.com.au",
          "logo": "https://schoolola.com.au/lovable-uploads/8577c389-5ccd-44bd-b04f-8b7121ad91d6.png",
          "sameAs": [
            "https://www.facebook.com/schoolola",
            "https://www.instagram.com/schoolola",
            "https://www.linkedin.com/company/schoolola"
          ],
          "contactPoint": [
            {
              "@type": "ContactPoint",
              "telephone": "(02) 9161 7167",
              "contactType": "customer service",
              "areaServed": "AU",
              "availableLanguage": "English"
            }
          ],
          "address": [
            {
              "@type": "PostalAddress",
              "streetAddress": "12 Ross Street",
              "addressLocality": "Parramatta",
              "addressRegion": "NSW",
              "postalCode": "2150",
              "addressCountry": "AU"
            }
          ],
          "serviceType": [
            "In-centre tutoring",
            "Online tutoring Australia-wide",
            "OC preparation", 
            "Selective School coaching",
            "Scholarship Exam preparation",
            "VSEC preparation",
            "NAPLAN preparation",
            "Primary and early secondary education (Kindergarten, Prep or Pre-primary to Year 8)"
          ],
          "audience": {
            "@type": "EducationalAudience",
            "educationalRole": "student",
            "audienceType": "Students from Kindergarten, Prep or Pre-primary to Year 8 across Australia"
          },
          "areaServed": [
            {
              "@type": "Country",
              "name": "Australia"
            },
            {
              "@type": "State",
              "name": "New South Wales",
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": -33.8688,
                "longitude": 151.2093
              }
            },
            {
              "@type": "State", 
              "name": "Victoria",
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": -37.8136,
                "longitude": 144.9631
              }
            }
          ],
          "hasOfferCatalog": buildHomepageOfferCatalog()
        };
      
      case 'centre':
        return data;
        
      case 'program':
        return data;
        
      default:
        return {};
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(generateSchemaMarkup())}
      </script>
    </Helmet>
  );
};

export default StructuredDataMarkup;